import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const backerFeatures = [
  {
    number: '1',
    title: 'Free Participation',
    description: 'Join campaigns without upfront costs.'
  },
  {
    number: '2',
    title: 'Royalty Earnings',
    description: 'Earn royalties through Spent and Unspent Tickets, plus Crypto Commissioner NFT royalties.'
  },
  {
    number: '3',
    title: 'Rewards and Perks',
    description: 'Gain access to exclusive perks, event tickets, or products based on package purchases and promotional efforts.'
  },
  {
    number: '4',
    title: 'Status System',
    description: 'Climb the ranks with Orca Badges to unlock higher rewards.'
  }
]

const BackerFeatures = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const items = sectionRef.current.querySelectorAll('.backer-feature-box')
    gsap.set(items, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to(items, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.2,
          ease: 'power3.out'
        })
      }
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="backer-features-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2>Key Features for Backers</h2>
        <div className="backer-feature-grid">
          {backerFeatures.map((feature, index) => (
            <div className="backer-feature-box" key={index}>
              <div className="backer-feature-header">
                <div className="number-circle">{feature.number}</div>
                <div className="gold-line"></div>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BackerFeatures
